import React from 'react';
import NavbarStandard from '../navbar/NavbarStandard';
import RegisterWizard from './RegisterWizard';
import Section from '../common/Section';
import bg1 from '../../assets/img/affiliate.jpg';
import Typed from 'react-typed';

export default function RegisterPage() {
  const SideBanner = () => {
    return (
      <div>
        <h1 className="text-white font-weight-light d-none d-xl-block">
          Affiliate Program for
          <Typed
            strings={[
              'Marketers',
              'Entrepreneurs',
              'Content Creators',
              'Educators',
              'Influencers',
              'Review Sites'
            ]}
            typeSpeed={40}
            backSpeed={50}
            className="font-weight-bold pl-2"
            loop
          />
          <br />
          business
        </h1>
        <p className="lead text-white">
          Become an Aasaan Affiliate and Earn more than ₹ 50,000 per month
        </p>
        <ul>
          <li>
            <strong>Earn 20% net recurring revenue on each purchase the subscription every year</strong>
          </li>
        </ul>
        <ul>
          <li>
            <strong>Refer your audience to Aasaan with your affiliate link
and earn up to Rs 4000 for each subscription.</strong>
          </li>
        </ul>
        <ul>
          <li>
            <strong>
            Affiliate dashboard to track your referrals and Income 
            </strong>
          </li>
        </ul>
        <p className="lead text-white">
          aasaan is an all-in-one solution for business owners to create, 
          run and grow their online business. We are trusted by over 1,00,000+ businesses all over India.
        </p>
      </div>
    );
  };
  return (
    <>
      <NavbarStandard />
      <Section
        className="py-0 pt-5 vh-100"
        image={bg1}
        position="center center"
        overlay
      >
        <div className="row pt-5">
          <div className="col col-8">
            <SideBanner />
          </div>
          <div className="col col-4 p-3 register-form-bg-color">
            <RegisterWizard />
          </div>
        </div>
      </Section>
    </>
  );
}
